import * as types from '../constants/actionTypes';
import lookingToMeetService from '../services/lookingToMeetService';
import introduceYourselfService from '../services/introduceYourselfService';
import WhatAreYourInterestsService from '../services/WhatAreYourInterestsService';
import { updateHeightSuccess } from './tellUsAboutYourselfAction';

export function updateCategorySuccess(data) {
  return { type: types.UPDATE_CATEGORY_SUCCESS, data };
}

export function updateMemberTypeSuccess(data) {
  return { type: types.UPDATE_MEMBER_TYPE_SUCCESS, data };
}

export function updateActionChangeCategotySuccess(data) {
  return { type: types.UPDATE_ACTION_CHANGE_CATEGORY_SUCCESS, data };
}

export function updateBackScreenSuccess(data) {
  return { type: types.UPDATE_BACK_SCREEN_SUCCESS, data };
}

export function updateSelectingCategorySuccess(data) {
  return { type: types.UPDATE_SELECTING_CATEGORY_SUCCESS, data };
}

export function updateSelectingCategoryItemSuccess(data) {
  return {
    type: types.UPDATE_SELECTING_PROFILE_BUILDER_ITEM_SUCCESS,
    data,
  };
}

export function changeMPBCategorySuccess(data) {
  return { type: types.MPB_CHANGE_CATEGORY_SUCCESS, data };
}

export function selectPropertyItemSuccess(data) {
  return { type: types.SELECT_PROPERTY_ITEM_SUCCESS, data };
}

export function updateStatusLoadMoreSuccess(data) {
  return {
    type: types.UPDATE_STATUS_LOAD_MORE_PROPERTY_ITEMS_SUCCESS,
    data,
  };
}

export function updateAgeRangeSuccess(data) {
  return { type: types.UPDATE_AGE_RANGE, data };
}

export function updateSelectingSubTabSuccess(data) {
  return { type: types.UPDATE_SUB_TAB_SUCCESS, data };
}

export function updateIndexTabSuccess(data) {
  return { type: types.UPDATE_INDEX_TAB, data };
}

export function updateValueSuccess(data) {
  return { type: types.UPDATE_VALUE_SUCCESS, data };
}

export function updateCanNextCategorySuccess(data) {
  return { type: types.UPDATE_CAN_NEXT_CATEGORY_SUCCESS, data };
}

export function updateRegistrationPropertyStateSuccess(data) {
  return { type: types.UPDATE_USER_REGISTER_PROPERTY_STATE, data };
}

export function addRegistrationPropertyStateSuccess(data) {
  return { type: types.ADD_REGISTRATION_PROPERTY_STATE, data };
}

export function mergeRegistrationPropertyStateSuccess(data) {
  return { type: types.MERGE_USER_REGISTER_PROPERTY_STATE, data };
}

export function calcRegistrationPropertyStateSuccess() {
  return { type: types.CALC_USER_REGISTER_PROPERTY_STATE };
}

export function resetStateSuccess() {
  return { type: types.RESET_STATE_USER_REGISTER };
}
export function selectPropertyItem(params) {
  return dispatch => {
    dispatch(selectPropertyItemSuccess(params));
  };
}

export function actionNext(data) {
  return dispatch => {
    dispatch(updateCategorySuccess(data));
  };
}

export function actionChangeCategory(updateInfoStep) {
  return dispatch => {
    dispatch(updateActionChangeCategotySuccess(updateInfoStep));
  };
}

export function actionBackScreen(backScreen) {
  return dispatch => {
    dispatch(updateBackScreenSuccess(backScreen));
  };
}

export function changeLTMCategory(data) {
  return dispatch => {
    dispatch(updateCategorySuccess(data));
  };
}

export function updateStatusLoadMore(params) {
  return dispatch => {
    dispatch(updateStatusLoadMoreSuccess(params));
  };
}

export function updateSelectingCategoryItem(params) {
  return dispatch => {
    return dispatch(updateSelectingCategoryItemSuccess(params));
  };
}

export function updateAgeRange(params) {
  return dispatch => {
    dispatch(updateAgeRangeSuccess(params));
  };
}

export function updateSelectingCategory(id) {
  return dispatch => {
    dispatch(updateSelectingCategorySuccess(id));
  };
}

export function updateMemberType(id) {
  return dispatch => {
    dispatch(updateMemberTypeSuccess(id));
  };
}

export function updateSelectingSubTab(pramas) {
  return dispatch => {
    dispatch(updateSelectingSubTabSuccess(pramas));
  };
}

export function updateIndexTab(params) {
  return dispatch => {
    dispatch(updateIndexTabSuccess(params));
  };
}

export function updateValue(data) {
  return dispatch => {
    dispatch(updateValueSuccess(data));
  };
}

export function updateCanNextCategory(data) {
  return dispatch => {
    dispatch(updateCanNextCategorySuccess(data));
  };
}

export function updateRegistrationPropertyState(data) {
  return dispatch => {
    dispatch(updateRegistrationPropertyStateSuccess(data));
  };
}

export function addRegistrationPropertyState(data) {
  return dispatch => {
    dispatch(addRegistrationPropertyStateSuccess(data));
  };
}

export function mergeRegistrationPropertyState(data) {
  return dispatch => {
    dispatch(mergeRegistrationPropertyStateSuccess(data));
  };
}

export function calcRegistrationPropertyState() {
  return dispatch => {
    dispatch(calcRegistrationPropertyStateSuccess());
  };
}

export function resetState() {
  return dispatch => {
    dispatch(resetStateSuccess());
  };
}
// export function choosePlaceSuccess(data) {
//     console.log(data)
//     return {type: types.UPDATE_USER_DETAIL_LOCATION, data: data};
// }
// export function choosePlace(data) {
//     return dispatch => {
//         dispatch(choosePlaceSuccess(data));
//     }
// }
